<div class="td-wb-learn-progress-bar">
  <div class="td-wb-learn-progress-bar__bar">
      <div class="td-wb-learn-progress-bar__fill" [style.width.%]="width()"></div>
      <span class="td-wb-vh">({{ width() }}%)</span>
  </div>
</div>
